import types from '../../types';

const user = (state = null, { type, payload }) => {
  switch (type) {
    case types.GET_USER_ACCOUNT_SUCCESS:
      return payload;

    case types.GET_USER_ACCOUNT_START:
    case types.GET_USER_ACCOUNT_FAILURE:
    case types.GET_USER_KYC_VERIFICATIONS_START:
    case types.GET_USER_KYC_VERIFICATIONS_FAILURE:
      return state;

    case types.GET_USER_KYC_VERIFICATIONS_SUCCESS:
      return { ...state, kyc_verifications: payload };
    // case types.UPDATE_USER_KYC_VERIFICATIONS_SUCCESS:
    //   return {
    //     ...state,
    //     kyc_verifications: state.kyc_verifications.map(item =>
    //       item.reference === payload.reference ? { ...item, ...payload } : item,
    //     ),
    //   };
    case types.PUT_CLEAR_USER_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        phone: '',
      };
    case types.PUT_SET_USER_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        phone: payload.data.phone,
      };

    default:
      return state;
  }
};

export default user;
